<div *transloco="let t" class="pt-4">
	@for (config of parameterConfigs; track config.name) {
		<div class="flex flex-col">
			<div style="font-weight: bolder" class="text-lg mt-4">
				{{ t('billing.' + config.name + 's') }}
			</div>

			<div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex flex-row justify-start items-center">
				<button (click)="addParameter(config.name)" class="m-2" color="primary" mat-raised-button type="submit">
					<mat-icon>add</mat-icon>
					<span>
						{{ t('billing.parameterValue.new' + config.name.toUpperCase()) }}
					</span>
				</button>
				<span class="flex-1"></span>
			</div>

			<table @stagger [dataSource]="config.dataSource" class="w-full" mat-table>
				<ng-container matColumnDef="description">
					<th *matHeaderCellDef mat-header-cell>{{ t('billing.description') }}</th>
					<td *matCellDef="let row" mat-cell>{{ row.description }}</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th *matHeaderCellDef mat-header-cell>{{ t('billing.name') }}</th>
					<td *matCellDef="let row" mat-cell>{{ row.name }}</td>
				</ng-container>

				<ng-container matColumnDef="printName">
					<th *matHeaderCellDef mat-header-cell>{{ t('common.printName') }}</th>
					<td *matCellDef="let row" mat-cell>{{ row.printname }}</td>
				</ng-container>

				<ng-container matColumnDef="validFrom">
					<th *matHeaderCellDef mat-header-cell>{{ t('common.from') }}</th>
					<td *matCellDef="let row" mat-cell>
						{{ dateUtil.setDateFormatByActiveLang(row.validFrom, '') }}
					</td>
				</ng-container>

				<ng-container matColumnDef="validTo">
					<th *matHeaderCellDef mat-header-cell>{{ t('common.till') }}</th>
					<td *matCellDef="let row" mat-cell>
						{{ dateUtil.setDateFormatByActiveLang(row.validTo, t('common.today')) }}
					</td>
				</ng-container>

				<ng-container matColumnDef="periodicity">
					<th *matHeaderCellDef mat-header-cell>{{ t('billing.periodicity') }}</th>
					<td *matCellDef="let row" mat-cell>{{ t('enum.' + row.periodicity) }}</td>
				</ng-container>

				@if (config.name === 'setting') {
					<ng-container matColumnDef="type">
						<th *matHeaderCellDef mat-header-cell>{{ t('billing.settingType') }}</th>
						<td *matCellDef="let row" mat-cell>{{ getTranslatedType(row.type, config.name) }}</td>
					</ng-container>
				} @else {
					<ng-container matColumnDef="type">
						<th *matHeaderCellDef mat-header-cell>{{ t('billing.type') }}</th>
						<td *matCellDef="let row" mat-cell>{{ getTranslatedType(row.type, config.name) }}</td>
					</ng-container>
				}

				<ng-container matColumnDef="validUserRole">
					<th *matHeaderCellDef mat-header-cell>{{ t('billing.validUserRole') }}</th>
					<td *matCellDef="let row" mat-cell>{{ getUserRoleString(row.validUserRole) }}</td>
				</ng-container>

				<ng-container matColumnDef="unit">
					<th *matHeaderCellDef mat-header-cell>{{ t('billing.unit') }}</th>
					<td *matCellDef="let row" mat-cell>{{ t('enum.' + row.unit) }}</td>
				</ng-container>

				<ng-container matColumnDef="options">
					<th *matHeaderCellDef mat-header-cell></th>
					<td *matCellDef="let row" mat-cell>
						<div class="flex flex-row items-center justify-end">
							<button (click)="editParameter(config.name, row)" color="primary" mat-icon-button>
								<mat-icon>edit</mat-icon>
							</button>
							<button (click)="deleteParameter(config.name, row)" color="primary" mat-icon-button>
								<mat-icon>delete</mat-icon>
							</button>
						</div>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="config.columns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: config.columns" @fadeInUp class="hover:bg-hover trans-ease-out cursor-pointer"></tr>
				<tr *matNoDataRow class="mat-row">
					<td class="mat-cell" [attr.colspan]="config.columns.length">
						<div class="ml-4">{{ t('dashboard.noDataFound') }}</div>
					</td>
				</tr>
			</table>

			<hr class="w-full my-4" />
		</div>
	}
</div>
